import React from "react"

export const useClickOutside = <T extends HTMLElement>(onClickOutside: () => void) => {
  const ref = React.useRef<T>(null)

  React.useEffect(() => {
    const handler = (e: FocusEvent) => {
      if (!ref.current) {
        return
      }

      if (!e.composedPath().includes(ref.current)) {
        onClickOutside()
      }
    }

    document.addEventListener("click", handler)
    return () => document.removeEventListener("click", handler)
  }, [ref.current])

  return ref
}
